module.exports = __webpack_public_path__ + "static/media/Butler_Ultra_Light.47903a19.otf";